import React, { useState, useEffect } from 'react';
// Modules
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import ToggleButton from 'react-bootstrap/ToggleButton';
import { FaTableList } from 'react-icons/fa6';
import { FaList } from 'react-icons/fa6';
// Context
import { useLogsData } from '../../../context/LogsContext';
// Form
import { serviceOriginOptions, serviceTypeOptions, servicePartnerOptions } from '../../../utils/Enums';
import useInput from '../../../components/form/hooks/useInput';
import DefaultSelect from '../../../components/form/inputs/DefaultSelect';
// Actions
import { list as workersList } from '../../../actions/workers';
// Icons
import { MdSearch, MdSearchOff } from 'react-icons/md';

export default function LogFilters() {
  // Form
  const {
    value: serviceTypeValue,
    valueChangeHandler: serviceTypeChangeHandler,
    inputBlurHandler: serviceTypeBlurHandler,
    reset: resetServiceType,
  } = useInput(() => {});
  const {
    value: servicePartnerValue,
    valueChangeHandler: servicePartnerChangeHandler,
    inputBlurHandler: servicePartnerBlurHandler,
    reset: resetServicePartner,
  } = useInput(() => {});
  const {
    value: serviceOriginValue,
    valueChangeHandler: serviceOriginChangeHandler,
    inputBlurHandler: serviceOriginBlurHandler,
    reset: resetServiceOrigin,
  } = useInput(() => {});
  const {
    value: workerValue,
    valueChangeHandler: workerChangeHandler,
    inputBlurHandler: workerBlurHandler,
    reset: resetWorker,
  } = useInput(() => {});

  // Context
  const { state, dispatch } = useLogsData();

  // State
  const [workersData, setWorkersData] = useState([]);
  const [servicePartnerOptionsFiltered, setServicePartnerOptionsFiltered] = useState(servicePartnerOptions);

  // useEffect
  useEffect(
    () => {
      const fetchWorkersData = async () => {
        await workersList({
          success: (data) => {
            setWorkersData(data);
          },
          error: (error) => {
            throw new Error('Failed to fetch workers data');
          },
        });
      };

      fetchWorkersData();
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  // Methods
  const clearForm = () => {
    resetServiceType();
    resetServicePartner();
    resetServiceOrigin();
    resetWorker();
  };

  const handleServiceTypeChange = (option) => {
    resetServicePartner(null);
    serviceTypeChangeHandler(option);

    setServicePartnerOptionsFiltered(
      option
        ? servicePartnerOptions.filter((partner) => {
            return partner.typeId === option.id;
          })
        : servicePartnerOptions
    );
  };

  const handleListViewMode = (mode) => {
    localStorage.setItem('LogsListViewMode', mode);

    dispatch({
      type: 'SET_LIST_VIEW_MODE',
      payload: mode,
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    dispatch({
      type: 'SET_FILTERS',
      payload: {
        ...state.filters,
        serviceType: serviceTypeValue ? serviceTypeValue.id : null,
        servicePartner: servicePartnerValue ? servicePartnerValue.id : null,
        serviceOrigin: serviceOriginValue ? serviceOriginValue.id : null,
        worker: workerValue ? workerValue.id : null,
      },
    });

    dispatch({
      type: 'SET_PAGER',
      payload: {
        ...state.pager,
        page: 1,
      },
    });
  };

  const radios = [
    { name: <FaTableList />, value: 0 },
    { name: <FaList />, value: 1 },
  ];

  return (
    <Form className="form--container" onSubmit={handleSubmit}>
      <Row className="mt-5">
        <Col md={1}>
          <ButtonGroup>
            {radios.map((radio, index) => (
              <ToggleButton
                key={index}
                id={`radio-${index}`}
                type="radio"
                name="radio"
                value={radio.value}
                checked={state.listViewMode === radio.value}
                onChange={() => handleListViewMode(radio.value)}
              >
                {radio.name}
              </ToggleButton>
            ))}
          </ButtonGroup>
        </Col>
        <Col md={11}>
          <Row md={5} className="d-flex justify-content-end">
            <DefaultSelect
              isClearable={true}
              showLabel={false}
              placeholder={'Tipo de Parceria'}
              instanceId={'serviceTypeSelect'}
              options={serviceTypeOptions}
              defaultValue={null}
              value={serviceTypeValue}
              onChange={handleServiceTypeChange}
              onBlur={serviceTypeBlurHandler}
            />
            <DefaultSelect
              isClearable={true}
              showLabel={false}
              placeholder={'Parceiro'}
              instanceId={'servicePartnerSelect'}
              options={servicePartnerOptionsFiltered}
              defaultValue={null}
              value={servicePartnerValue}
              onChange={servicePartnerChangeHandler}
              onBlur={servicePartnerBlurHandler}
            />
            <DefaultSelect
              isClearable={true}
              showLabel={false}
              placeholder={'Origem'}
              instanceId={'serviceOriginSelect'}
              options={serviceOriginOptions}
              defaultValue={null}
              value={serviceOriginValue}
              onChange={serviceOriginChangeHandler}
              onBlur={serviceOriginBlurHandler}
            />
            <DefaultSelect
              isClearable={true}
              showLabel={false}
              placeholder={'Colaborador'}
              instanceId={'workerSelect'}
              options={workersData}
              getOptionLabel={(option) => `${option.name}`}
              defaultValue={null}
              value={workerValue}
              onChange={workerChangeHandler}
              onBlur={workerBlurHandler}
            />
            <div className="filter--btn">
              <Button type={'submit'} className="me-2">
                <MdSearch /> Pesquisar
              </Button>
              <Button onClick={clearForm}>
                <MdSearchOff />
                Limpar
              </Button>
            </div>
          </Row>
        </Col>
      </Row>
    </Form>
  );
}
